import React from "react";
import PropTypes from "prop-types";
import { Select } from "@opendate-app/setlist";

const NOT_SHARED = "";

const DEFAULT_HINT = "A shared product sells until its own capacity or the pool runs out, whichever comes first.";

const InventoryPoolSelect = ({ pools, value, onChange, lockedReason, joinWarning }) => {
  if (pools.length === 0) return null;

  const options = [
    { value: NOT_SHARED, label: "Not shared" },
    ...pools.map((pool) => ({
      value: String(pool.id),
      label: `${pool.name} (${pool.remaining} of ${pool.capacity} left)`,
    })),
  ];

  return (
    <div className="mb-3" data-testid="pass-inventory-pool">
      <Select
        id="pass-inventory-pool"
        name="series_pass_inventory_pool_id"
        label="Shared inventory"
        options={options}
        value={value}
        disabled={Boolean(lockedReason)}
        onChange={(selected) => onChange(selected == null ? NOT_SHARED : String(selected))}
        hint={lockedReason || (value !== NOT_SHARED && joinWarning) || DEFAULT_HINT}
      />
    </div>
  );
};

InventoryPoolSelect.propTypes = {
  pools: PropTypes.arrayOf(PropTypes.object).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  lockedReason: PropTypes.string,
  joinWarning: PropTypes.string,
};

export default InventoryPoolSelect;
